import z from "zod";

export const openingHoursSchema = z.object({
	id: z.number().nullable(),
	mondayFrom: z.number().nullable(),
	mondayTo: z.number().nullable(),
	tuesdayFrom: z.number().nullable(),
	tuesdayTo: z.number().nullable(),
	wednesdayFrom: z.number().nullable(),
	wednesdayTo: z.number().nullable(),
	thursdayFrom: z.number().nullable(),
	thursdayTo: z.number().nullable(),
	fridayFrom: z.number().nullable(),
	fridayTo: z.number().nullable(),
	saturdayFrom: z.number().nullable(),
	saturdayTo: z.number().nullable(),
	sundayFrom: z.number().nullable(),
	sundayTo: z.number().nullable(),
});
